function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n            .cls-1-port{fill:#fff;}.cls-2-port,.cls-4-port,.cls-5-port{fill:none;stroke:#adafb5;}.cls-2-port,.cls-5-port{stroke-miterlimit:10;}.cls-3-port{fill:#adafb5;}.cls-4-port{stroke-linejoin:round;}.cls-5-port{stroke-linecap:round;}\n        "));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1-port",
  d: "M59.62,60.27.37,60A.38.38,0,0,1,0,59.63V.37A.38.38,0,0,1,.38,0L59.63.27A.38.38,0,0,1,60,.65V59.9A.37.37,0,0,1,59.62,60.27Z"
}), React.createElement("line", {
  className: "cls-2-port",
  x1: 36.92,
  y1: 45.53,
  x2: 42.54,
  y2: 39.34
}), React.createElement("path", {
  className: "cls-2-port",
  d: "M17.46,19.73l11.3-2.48v-3.7a2.79,2.79,0,0,1,2.79-2.79h8.19a2.79,2.79,0,0,1,2.8,2.79v3.5l-5.77,2.68"
}), React.createElement("circle", {
  className: "cls-2-port",
  cx: 35.22,
  cy: 14.01,
  r: 1.59
}), React.createElement("line", {
  className: "cls-2-port",
  x1: 28.76,
  y1: 17.25,
  x2: 42.11,
  y2: 17.05
}), React.createElement("path", {
  className: "cls-2-port",
  d: "M42.54,39.15v5.36a2.71,2.71,0,0,1-2.71,2.7H28.06a1.54,1.54,0,0,1-1.55-1.55v-.27"
}), React.createElement("line", {
  className: "cls-2-port",
  x1: 42.54,
  y1: 17.39,
  x2: 42.54,
  y2: 39.5
}), React.createElement("rect", {
  className: "cls-3-port",
  x: 21.77,
  y: 24.06,
  width: 10.69,
  height: 1.15
}), React.createElement("rect", {
  className: "cls-3-port",
  x: 23.15,
  y: 25.21,
  width: 7.93,
  height: 1.6
}), React.createElement("rect", {
  className: "cls-3-port",
  x: 21.77,
  y: 39.96,
  width: 10.69,
  height: 1.15,
  transform: "translate(54.24 81.07) rotate(180)"
}), React.createElement("rect", {
  className: "cls-3-port",
  x: 23.15,
  y: 38.35,
  width: 7.93,
  height: 1.6,
  transform: "translate(54.24 78.31) rotate(180)"
}), React.createElement("circle", {
  className: "cls-2-port",
  cx: 27.12,
  cy: 32.34,
  r: 4.29
}), React.createElement("circle", {
  className: "cls-3-port",
  cx: 27.12,
  cy: 32.34,
  r: 2.45
}), React.createElement("polygon", {
  className: "cls-4-port",
  points: "36.74 30.11 40.38 28.09 40.46 31.37 36.77 34.01 36.77 45.39 17.46 45.39 17.46 19.73 36.77 19.73 36.74 30.11"
}), React.createElement("path", {
  className: "cls-5-port",
  d: "M36.77,30.14H35a.38.38,0,0,1-.37-.38v-7.7h-15V42.73h15V34.39A.38.38,0,0,1,35,34h1.77"
})));

function SvgPort(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60.27"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/port.d6969daa.svg";
export { SvgPort as ReactComponent };